import request from '@/utils/request'
var qs = require("qs")

export function login(username, password,code,uuid) {
  return request({
    url: '/admin/login',
    method: 'post',
    data: {
      username,
      password,
      code,
      uuid,
    }
  })
}
// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captcha/captchaImage',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}

export function getInfo() {
  return request({
    url: '/admin/info',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/admin/logout',
    method: 'post'
  })
}

export function fetchList(params) {
  return request({
    url: '/user/list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/user/register',
    method: 'post',
    data: data
  })
}

//创建专家信息
export function createExpert(data) {
  return request({
    url: '/user/expertRegister',
    method: 'post',
    data: data
  })
}

export function updateAdmin(data) {
  return request({
    url: '/user/update',
    method: 'post',
    data: data
  })
}

export function updateTwo(data) {
  return request({
    url: '/user/updateTwo',
    method: 'post',
    data: data
  })
}

// 用户密码重置
export function resetUserPwd(userId,password) {
  const data = {
    userId,
    password
  }
  return request({
    url: '/user/updatePassword',
    method: 'post',
    data: data
  })
}

// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
  const data = {
    oldPassword,
    newPassword
  }
  return request({
    url: '/user/updatePwd',
    method: 'put',
    params: data
  })
}

export function updateStatus(params) {
  return request({
    url: '/user/updateStatus/',
    method: 'post',
    params: params
  })
}
export function getUserById(userId) {
  return request({
    url: '/user/byId',
    method: 'get',
    params: {id:userId},
  })
}

export function getUserinfo() {
  return request({
    url: '/user',
    method: 'get',
  })
}

export function getUserInfo(userId) {
  return request({
    url: '/user/getInfo?'+qs.stringify({userId,userId}, {arrayFormat: 'repeat'}),
    method: 'get',
  })
}

export function deleteAdmin(userId) {
  return request({
    url: '/user/delete/',
    method: 'post',
    data: qs.stringify({userId,userId}, {arrayFormat: 'repeat'}),
  })
}

// 查询授权角色
export function getAuthRole(userId) {
  return request({
    url: '/user/getAuthRole/',
    method: 'get',
    params: {userId,userId}
  })
}

// 保存授权角色
export function updateAuthRole(data) {
  return request({
    url: '/user/updateAuthRole',
    method: 'post',
    data: qs.stringify(data, {arrayFormat: 'repeat'}),
  })
}

// 获取路由
export function getRouters(){
  return request({
    url: '/admin/getRouters',
    method: 'get'
  })
}

//查询用户列表（专家信息）
export function listByExpert(params) {
  return request({
    url: '/user/listByExpert',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js